<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">Notas Fiscais</span>
                    </b-card-header>
                    <b-card-body>
                        <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                        ></app-erros-box>

                        <app-tabela
                            idTabela="tblNotasFiscais"
                            :itens="notasFiscais"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                            :bordered="false"
                            :small="false"
                        >
                            <template slot="botoes">
                                <b-button-group class="float-right">
                                    <b-button
                                        variant="primary"
                                        @click="abrirModalInserir()"
                                        v-if="temPermissaoInserir"
                                    >
                                        <i class="fa fa-plus"></i> Inserir Nota Fiscal
                                    </b-button>
                                </b-button-group>
                            </template>

                            <template slot="numeroNota" slot-scope="data">
                                {{ data.numeroNota }}
                            </template>

                            <template slot="dataEmissao" slot-scope="data">
                                <span v-if="data.dataEmissao">{{ $moment(data.dataEmissao).format('DD/MM/YYYY') }}</span>
                                <span v-else>-</span>
                            </template>

                            <template slot="valorNota" slot-scope="data">
                                <span v-if="data.valorNota">{{ data.valorNota | currency }}</span>
                                <span v-else>-</span>
                            </template>

                            <template slot="prestadorRazaoSocial" slot-scope="data">
                                {{ data.prestadorRazaoSocial }}
                            </template>

                            <template slot="acoes" slot-scope="data">
                                <div class="d-flex align-items-center">
                                    <!-- Visualizar informações da nota fiscal -->
                                    <pagamento-nota-fiscal-detalhes
                                        :pagamentoNotaFiscal="data"
                                        :pagamentosServicos="pagamentosServicos"
                                        :pagamentoConcluido="pagamentoConcluido"
                                        :valorTotal="valorTotal"
                                        @atualizar="obterNotasFiscais()"
                                    ></pagamento-nota-fiscal-detalhes>

                                   
                                    <!-- Visualizar documento no modal -->
                                    <pagamento-nota-fiscal-visualizar-anexo
                                        v-if="!isFornecedorContext"
                                        :pagamentoNotaFiscal="data"
                                        :pagamentosServicos="pagamentosServicos"
                                    ></pagamento-nota-fiscal-visualizar-anexo>
                                    
                                    <pagamento-nota-fiscal-visualizar-anexo-fornecedor
                                        v-if="isFornecedorContext"
                                        :pagamentoNotaFiscal="data"
                                        :pagamentosServicos="pagamentosServicos"
                                    ></pagamento-nota-fiscal-visualizar-anexo-fornecedor>

                                   

                                    <!-- Excluir nota fiscal -->
                                    <span class="text-danger ml-2" v-if="temPermissaoExcluir">
                                        <i
                                            class="fa fa-trash fa-lg icon-button"
                                            title="Excluir"
                                            @click="confirmarExclusao(data)"
                                        ></i>
                                    </span>
                                </div>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>

        <!-- Modal de Inserir/Atualizar -->
        <pagamento-nota-fiscal-form
            :mostrarModal="mostrarModal"
            :operacao="operacao"
            :pagamentoId="pagamentoId"
            :pagamentosServicos="pagamentosServicos"
            :erros="errosForm"
            :valorTotal="valorTotal"
            @salvar="salvarNotaFiscal($event)"
            @fechar="fecharModal()"
        ></pagamento-nota-fiscal-form>

        <!-- Modal de Confirmação de Exclusão -->
        <b-modal
            v-model="mostrarModalExclusao"
            title="Confirmar Exclusão"
            ok-title="Sim, excluir"
            cancel-title="Cancelar"
            ok-variant="danger"
            @ok="excluirNotaFiscal"
            @cancel="fecharModalExclusao"
        >
            <p>
                Deseja realmente excluir a nota fiscal
                <strong>{{ notaFiscalSelecionada.numeroNota }}</strong>?
            </p>
        </b-modal>
    </div>
</template>

<script>
import PagamentoNotaFiscalForm from './PagamentoNotaFiscalFormNovo.vue'
import PagamentoNotaFiscalVisualizacao from './PagamentoNotaFiscalVisualizacao.vue'
import PagamentoNotaFiscalVisualizarAnexo from './PagamentoNotaFiscalVisualizarAnexo.vue'
// Importação condicional baseada no contexto
import PagamentoNotaFiscalVisualizarAnexoFornecedor from '@/app/fornecedor/contratos/pagamentos/PagamentoNotaFiscalVisualizarAnexo.vue'
import PagamentoNotaFiscalDownload from './PagamentoNotaFiscalDownload.vue'
import PagamentoNotaFiscalDetalhes from './PagamentoNotaFiscalDetalhes.vue'

export default {
    props: {
        pagamentoId: {
            type: String,
            required: true
        },
        pagamentosServicos: {
            type: Object,
            required: true
        },
        temPermissaoInserir: {
            type: Boolean,
            default: true
        },
        temPermissaoExcluir: {
            type: Boolean,
            default: true
        },
        pagamentoConcluido: {
            type: Boolean,
            default: false
        },
        valorTotal: {
            type: Number,
            default: 0
        }
    },

    components: {
        PagamentoNotaFiscalForm,
        PagamentoNotaFiscalVisualizacao,
        PagamentoNotaFiscalVisualizarAnexo,
        PagamentoNotaFiscalVisualizarAnexoFornecedor,
        PagamentoNotaFiscalDownload,
        PagamentoNotaFiscalDetalhes
    },

    data() {
        return {
            notasFiscais: [],
            erros: [],
            errosForm: [],
            mostrarModal: false,
            mostrarModalExclusao: false,
            operacao: 'INSERIR',
            notaFiscalSelecionada: {},
            itensPorPagina: 0,
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'numeroNota',
                    label: 'Número da NF',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataEmissao',
                    label: 'Data Emissão da NF',
                    type: 'date'
                },
                {
                    key: 'valorNota',
                    label: 'Valor da NF',
                    type: 'currency'
                },
                {
                    key: 'prestadorRazaoSocial',
                    label: 'Prestador',
                    sortable: true,
                    filterable: true
                }
            ]
        }
    },

    computed: {
        // Detecta se estamos no contexto de fornecedor baseado na rota ou na URL da API
        isFornecedorContext() {
            // Verifica se a rota contém 'fornecedor'
            if (this.$route.path.includes('fornecedor')) {
                return true
            }
            
            // Verifica se o serviço está usando a API de fornecedor
            if (this.pagamentosServicos && this.pagamentosServicos.downloadNotaFiscal) {
                const funcStr = this.pagamentosServicos.downloadNotaFiscal.toString()
                if (funcStr.includes('/fornecedor/contratos/pagamentos/')) {
                    return true
                }
            }
            
            return false
        }
    },

    mounted() {
        this.obterNotasFiscais()
    },

    methods: {
        async obterNotasFiscais() {
            try {
                this.$store.dispatch('addRequest')
                const response = await this.pagamentosServicos.obterNotasFiscais(this.$route.params.pagamentoId)
                
                if (response && response.success) {
                    this.notasFiscais = response.data
                    this.erros = []
                } else {
                    this.erros = response.errors || ['Erro ao obter notas fiscais']
                }
            } catch (error) {
                this.erros = ['Erro ao carregar notas fiscais']
                console.error('Erro ao obter notas fiscais:', error)
            } finally {
                this.$store.dispatch('removeRequest')
            }
        },

        abrirModalInserir() {
            this.operacao = 'INSERIR'
            this.errosForm = []
            this.mostrarModal = true
        },

        async salvarNotaFiscal(notaFiscal) {
            try {
                this.$store.dispatch('addRequest')
                const response = await this.pagamentosServicos.inserirPagamentoNotaFiscal(notaFiscal)
                
                if (response && response.success) {
                    this.$toast.success(
                        'Nota fiscal salva com sucesso!',
                        'SUCESSO',
                        this.$toastConfig.success
                    )
                    this.fecharModal()
                    this.obterNotasFiscais() 
                    this.$emit('atualizar') 
                } else {
                    this.errosForm = response.errors || ['Erro ao salvar nota fiscal']
                }
            } catch (error) {
                this.errosForm = ['Erro interno do servidor']
                console.error('Erro ao salvar nota fiscal:', error)
            } finally {
                this.$store.dispatch('removeRequest')
            }
        },

        confirmarExclusao(notaFiscal) {
            this.notaFiscalSelecionada = notaFiscal
            this.mostrarModalExclusao = true
        },

        async excluirNotaFiscal(bvModalEvt) {
          
            if (bvModalEvt) {
                bvModalEvt.preventDefault()
            }

            try {
                this.$store.dispatch('addRequest')
                
                const response = await this.pagamentosServicos.excluirNotaFiscal(
                    this.pagamentoId, 
                    this.notaFiscalSelecionada.pagamentoNotaFiscalId
                )
                
                if (response && response.success) {
                    this.$toast.success(
                        'Nota fiscal excluída com sucesso!',
                        'SUCESSO',
                        this.$toastConfig.success
                    )
                    this.fecharModalExclusao()
                    this.obterNotasFiscais() // Recarrega a lista
                    this.$emit('atualizar') // Notifica o componente pai
                } else {
                    this.erros = response.errors || ['Erro ao excluir nota fiscal']
                }
            } catch (error) {
                this.erros = ['Erro interno do servidor']
                console.error('Erro ao excluir nota fiscal:', error)
            } finally {
                this.$store.dispatch('removeRequest')
                // Fechar o modal após a operação
                if (bvModalEvt) {
                    this.$nextTick(() => {
                        bvModalEvt.vueTarget.hide()
                    })
                }
            }
        },

        fecharModal() {
            this.mostrarModal = false
            this.errosForm = []
        },

        fecharModalExclusao() {
            this.mostrarModalExclusao = false
            this.notaFiscalSelecionada = {}
        }
    }
}
</script>

<style scoped>
.icon-button {
    cursor: pointer;
}

.icon-button:hover {
    opacity: 0.7;
}
</style>
